import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CURRENT_BRAND } from '../App';


export function useCurrentBrand() {

    const [currentBrand, setCurrentBrand] = useState(CURRENT_BRAND);
    const brandConfig = useSelector((state: any) => state.config?.brand);

    useEffect(() => {
        let brand = CURRENT_BRAND;
        if (process.env.CURRENT_MODE === 'standalone') {
            const urlBrand = new URLSearchParams(window.location.search).get("brand");
            if (urlBrand) {
                brand = urlBrand;

            }
        } else {
            brand = brandConfig || CURRENT_BRAND;
            //brand = 'sun.default';
        }
        if (brand) {
            setCurrentBrand(brand);
            console.log('selecting brand ', brand)
        }

    }, [brandConfig])


    return currentBrand;

}
